module.exports = {"date":null,"net_worth":0}


//////////////////
// WEBPACK FOOTER
// ./src/components/documents/resources/financial_statement.json
// module id = HvmJ
// module chunks = 1